module.exports = __webpack_public_path__ + "static/transparent-pixel-85272a624efdbfcfd0cc2459e40f7d76.png";